module.exports = __webpack_public_path__ + "static/media/bg7.5085cd8a.jpg";